module.exports = __webpack_public_path__ + "442adeaf21c395da38b1c2182604abc7.png";


//////////////////
// WEBPACK FOOTER
// ./components/bare_home/berkshire.png
// module id = 596
// module chunks = 0